module.exports = __webpack_public_path__ + "img/2D2D2F_C6C2C5_727176_94949B-256px.114b90fb.png";